export const ChangeFlowStatus = (builder) => ({
    ChangeFlowStatus: builder.mutation({
        query: (body) => {
            const token = JSON.parse(localStorage.getItem('TOKEN'))?.token || '';
            return {
                url: process.env.REACT_APP_CHATBOT_API_PORT + '/chat/updateStatus', // Adjusted to match your curl endpoint
                method: 'POST',
                body: body, // Pass formData directly as the request body
                headers: {
                    'Authorization': token,
                },
            };
        },
    }),
});
